import {QUERY_KEY} from 'hooks/queries';
import {queryClient} from 'react-query';
import {QuoteAddress} from 'types/Quoting';

const BASE_ADDRESS_QUERY_KEY = [QUERY_KEY.QUOTING, 'baseAddress'];

export const setBaseAddress = (baseAddress: QuoteAddress | undefined) =>
  queryClient.setQueryData(BASE_ADDRESS_QUERY_KEY, baseAddress);

export const getBaseAddress = (): QuoteAddress | undefined => queryClient.getQueryData(BASE_ADDRESS_QUERY_KEY);

export const removeQuotingCache = () => queryClient.removeQueries({queryKey: [QUERY_KEY.QUOTING]});
